import { map, mergeMap } from "rxjs/operators";
import { inject, injectable } from "tsyringe";

import { autoBind } from "src/shared/decorators/autobind";
import { CampaignBanner, LayeredBannerDesign } from "src/containers/home/types";
import { AdvertisingRepository } from "src/containers/home/repositories/banner/banner-repository";
import {
    insertCustomBannerIntoResponse,
    insertTagManagerEventIntoResponse,
} from "src/containers/home/utils/inserted-scratch-banner-helper";

@injectable()
export class AdvertisingService {
    constructor(
        @inject("AdvertisingRepository") private repo: AdvertisingRepository
    ) {}

    private sortByOrder = (banners: CampaignBanner[]) =>
        (banners as CampaignBanner<LayeredBannerDesign>[]).sort(
            (a, b) =>
                (a.design.metadata?.order ?? 0) -
                (b.design.metadata?.order ?? 0)
        );

    @autoBind
    getCampaigns(): Promise<CampaignBanner[]> {
        return this.repo
            .getCampaigns()
            .pipe(
                map(this.sortByOrder),
                mergeMap(insertCustomBannerIntoResponse),
                mergeMap(insertTagManagerEventIntoResponse)
            )
            .toPromise();
    }

    static getCampaingnsUrl(): string {
        return "insureds/me/banner";
    }
}
